import React from 'react';

import { Box, FormControl, InputLabel, MenuItem } from '@material-ui/core';

import { FilterPills } from '@vyce/core/src/components/FilterPills';
import { AppSelect } from '@vyce/core/src/components/inputs';

import { ALL_USERS_FILTER, INVITE_MODULES_CONFIG, InviteModuleConfig } from '../constants';
import { InviteModuleKey, ResourceOption, WorkersFilter } from '../types';

interface Props {
  filter: WorkersFilter;
  onChange: (filter: WorkersFilter) => void;
  /** Modules the company has resources for — the pills */
  modules: InviteModuleConfig[];
  /** Resources of the picked module — the dependent select */
  resourceOptions: ResourceOption[];
}

const RESOURCE_SELECT_ID = 'invite-existing-users-resource';

export const ExistingUsersFilters: React.FC<Props> = ({ filter, onChange, modules, resourceOptions }) => {
  const config = filter.module ? INVITE_MODULES_CONFIG[filter.module] : null;
  const pillOptions = [
    { value: ALL_USERS_FILTER, label: 'All users' },
    ...modules.map(module => ({ value: module.key as string, label: module.label })),
  ];

  const handleModuleChange = (value: string) => {
    onChange({ module: value === ALL_USERS_FILTER ? null : (value as InviteModuleKey), resourceId: null });
  };

  return (
    <Box display="flex" flexDirection="column" gridGap={12}>
      <FilterPills
        options={pillOptions}
        value={filter.module ?? ALL_USERS_FILTER}
        onChange={handleModuleChange}
        ariaLabel="Filter users by module"
      />

      {config && (
        <FormControl variant="filled" fullWidth>
          <InputLabel shrink id={RESOURCE_SELECT_ID}>
            Which {config.resourceLabel}?
          </InputLabel>
          <AppSelect
            labelId={RESOURCE_SELECT_ID}
            displayEmpty
            value={filter.resourceId ?? ''}
            onChange={event => onChange({ ...filter, resourceId: (event.target.value as string) || null })}
          >
            <MenuItem value="">All {config.resourceLabelPlural}</MenuItem>
            {resourceOptions.map(option => (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            ))}
          </AppSelect>
        </FormControl>
      )}
    </Box>
  );
};
